import React from 'react';
import LegalPage from './LegalPage';

const TermsPage = () => {
  return (
    <LegalPage title="Terms & Conditions" slug="terms" lastUpdated="January 2026">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">1. Agreement to Terms</h2>
        <p className="text-zinc-700 leading-relaxed">
          By accessing and using Indicraft, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, please do not use our services.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">2. Use of Website</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">You agree to:</p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Provide accurate and complete information</li>
          <li>Maintain the security of your account</li>
          <li>Not use the website for any illegal purposes</li>
          <li>Not interfere with the website's operation</li>
          <li>Not impersonate any person or entity</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">3. Products and Pricing</h2>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>All prices are in Indian Rupees (INR) and include applicable taxes</li>
          <li>Prices are subject to change without notice</li>
          <li>Product images are for reference; actual products may vary</li>
          <li>We reserve the right to limit quantities</li>
          <li>Product availability is subject to stock</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">4. Orders and Payment</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          By placing an order, you make an offer to purchase products. We reserve the right to accept or reject any order. Payment must be made at the time of order placement (except for COD orders).
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">5. Shipping and Delivery</h2>
        <p className="text-zinc-700 leading-relaxed">
          Delivery times are estimates and may vary. We are not liable for delays caused by factors beyond our control. Title and risk of loss pass to you upon delivery.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">6. Returns and Refunds</h2>
        <p className="text-zinc-700 leading-relaxed">
          Returns are subject to our Return Policy. Refunds will be processed to the original payment method within 5-7 business days of receiving the returned item.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">7. Intellectual Property</h2>
        <p className="text-zinc-700 leading-relaxed">
          All content on this website, including text, images, logos, and software, is owned by Indicraft and protected by copyright laws. You may not reproduce, distribute, or modify any content without written permission.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">8. Limitation of Liability</h2>
        <p className="text-zinc-700 leading-relaxed">
          Indicraft shall not be liable for any indirect, incidental, or consequential damages arising from the use of our website or products. Our total liability shall not exceed the purchase price of the product.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">9. Governing Law</h2>
        <p className="text-zinc-700 leading-relaxed">
          These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Mumbai, Maharashtra.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">10. Contact Information</h2>
        <p className="text-zinc-700 leading-relaxed">
          For questions about these terms, contact us at:<br />
          Email: legal@indicraft.in<br />
          Phone: +91 123-456-7890
        </p>
      </section>
    </LegalPage>
  );
};

export default TermsPage;
